if (!customElements.get('ctr-cart-subscription-toggle')) {
  customElements.define(
    'ctr-cart-subscription-toggle',
    class CtrCartSubscriptionToggle extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('.ctr-cart-subscription-toggle__input');
        this.checkbox.addEventListener('change', this.handleChange.bind(this));
      }

      get isSubscribed() {
        return this.checkbox.checked;
      }

      get itemKey() {
        return this.dataset.itemKey;
      }

      get variantId() {
        return this.dataset.variantId;
      }

      get quantity() {
        return parseInt(this.dataset.quantity, 10);
      }

      get sellingPlanId() {
        return this.dataset.sellingPlanId;
      }

      async handleChange() {
        if (this.loading) {
          // Revert the checkbox while loading
          this.checkbox.checked = !this.checkbox.checked;
          return;
        }

        this.loading = true;
        this.classList.add('ctr-cart-subscription-toggle--loading');

        try {
          if (this.isSubscribed) {
            // Toggled on → switch to subscription
            await this.updateSellingPlan(this.sellingPlanId);
          } else {
            // Toggled off → switch to one-time purchase
            await this.updateSellingPlan('');
          }

          await this.refreshCartDrawer();

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ctr-cart-subscription-toggle',
          });
        } catch (error) {
          console.error('[ctr-cart-subscription-toggle] Error updating selling plan:', error);
          // Revert checkbox on error
          this.checkbox.checked = !this.checkbox.checked;
        } finally {
          this.loading = false;
          this.classList.remove('ctr-cart-subscription-toggle--loading');
        }
      }

      /**
       * Update the selling plan for the line item via /cart/change.js
       * @param {string} sellingPlanId - The selling plan ID to apply, or empty string to remove
       */
      async updateSellingPlan(sellingPlanId) {
        const body = {
          id: this.itemKey,
          quantity: this.quantity,
          selling_plan: sellingPlanId ? parseInt(sellingPlanId, 10) : '',
        };

        const response = await fetch(routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          throw new Error(`Cart change failed: ${response.status}`);
        }

        return response.json();
      }

      /**
       * Refresh the cart drawer sections after the selling plan change
       */
      async refreshCartDrawer() {
        const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const targetInner = document.querySelector('cart-drawer .drawer__inner');
        const sourceInner = doc.querySelector('.drawer__inner');
        if (targetInner && sourceInner) {
          targetInner.innerHTML = sourceInner.innerHTML;
        }
        const overlay = document.querySelector('#CartDrawer-Overlay');
        const drawer = document.querySelector('cart-drawer');
        if (overlay && drawer) {
          overlay.addEventListener('click', () => drawer.close());
        }

        // Update cart icon bubble
        const newBubble = doc.querySelector('.cart-count-bubble');
        const currentBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      }
    }
  );
}
